import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnInit, AfterViewInit, OnDestroy, ElementRef, NgZone, HostListener } from '@angular/core';
import { WorkspaceDialogFocus } from "src/libs/portal/review/workspace-ui";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.reviewops-shell {
  height: 100%;
  overflow: hidden;
}

.reviewops-content {
  height: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.reviewops-route-stage {
  position: relative;
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

:host ::ng-deep .reviewops-route-stage > router-outlet + * {
  display: block;
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
}

:host ::ng-deep .reviewops-route-stage > router-outlet + wiz-page-project-resource-editor {
  overflow: hidden;
}

/* With no transformed ancestor, every fixed dialog uses the viewport. */
:host ::ng-deep .reviewops-route-stage > router-outlet + *:has(> :is(.qa-generation-running-backdrop, .qa-source-modal-backdrop, .project-setting-modal-backdrop, .project-resource-preview-backdrop, .ops-modal-backdrop, .project-modal-backdrop)) {
  overflow: hidden;
}

.reviewops-sidebar {
  background: #F6F7F5;
  box-shadow: inset -1px 0 #D9DFD7;
}

.reviewops-sidebar--persistent {
  position: fixed;
  inset: 0 auto 0 calc(-1 * var(--ro-sidebar-width));
  z-index: 40;
  display: flex;
  flex-direction: column;
  width: var(--ro-sidebar-width);
  pointer-events: none;
}

.reviewops-sidebar--persistent > wiz-component-nav-sidebar {
  visibility: hidden;
}

:host ::ng-deep .reviewops-sidebar--persistent :is(.floating-ai-launcher, .floating-ai) {
  visibility: visible;
  pointer-events: auto;
}

:host ::ng-deep .reviewops-sidebar--mobile-drawer :is(.floating-ai-launcher, .floating-ai) {
  display: none;
}

.reviewops-mobile-header {
  min-height: 64px;
  border-color: #D9DFD7;
  background: white;
}

@media (min-width: 1024px) {
  .reviewops-sidebar--persistent {
    left: 0;
    pointer-events: auto;
  }
  .reviewops-sidebar--persistent > wiz-component-nav-sidebar {
    visibility: visible;
  }
  .reviewops-content {
    padding-left: var(--ro-sidebar-width);
  }
  :host ::ng-deep .reviewops-sidebar--persistent .reviewops-nav__brand {
    height: var(--reviewops-brand-row-size, var(--ro-header-min));
    flex-shrink: 0;
  }
}
@media (max-width: 1023px) {
  :host ::ng-deep .reviewops-route-stage > router-outlet + wiz-page-project-resource-editor {
    overflow-y: auto;
  }
}`],
})
export class LayoutSidebarComponent implements OnInit, AfterViewInit, OnDestroy {
    public mobileNavOpen: boolean = false;
    private headerResize?: ResizeObserver;
    private routeChanges?: MutationObserver;
    private rowFrame: number = 0;
    private rowDestroyed: boolean = false;
    private rowHeader: HTMLElement | null = null;
    private rowStage: HTMLElement | null = null;
    private rowSidebar: HTMLElement | null = null;
    private rowNav: HTMLElement | null = null;
    private navOpener: HTMLElement | null = null;
    private workspaceDialogs?: WorkspaceDialogFocus;

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef<HTMLElement>)  private element: ElementRef<HTMLElement>,@Inject( NgZone)  private zone: NgZone) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public ngAfterViewInit() {
        this.zone.runOutsideAngular(() => {
            this.workspaceDialogs = new WorkspaceDialogFocus(this.element.nativeElement, () => this.mobileNavOpen || this.service.modal.isshow);
        });
        // Header and sidebar share CSS pixels. Measure only the separate brand row.
        this.rowStage = this.element.nativeElement.querySelector('.reviewops-route-stage');
        this.rowSidebar = this.element.nativeElement.querySelector('.reviewops-sidebar--persistent');
        this.rowNav = this.rowSidebar?.querySelector('.reviewops-nav') || null;
        if (!this.rowStage || !this.rowSidebar || !this.rowNav) return;
        this.zone.runOutsideAngular(() => {
            // This only sizes the separate sidebar, so it cannot resize the
            // observed header. Apply before paint instead of adding a frame.
            this.headerResize = new ResizeObserver(this.syncHeaderRow);
            this.routeChanges = new MutationObserver(this.queueHeaderRow);
            this.routeChanges.observe(this.rowStage!, { childList: true, subtree: true });
            window.addEventListener('resize', this.queueHeaderRow);
            this.queueHeaderRow();
        });
    }

    private queueHeaderRow = () => {
        if (this.rowDestroyed || this.rowFrame) return;
        this.rowFrame = window.requestAnimationFrame(() => {
            this.rowFrame = 0;
            this.syncHeaderRow();
        });
    };

    private syncHeaderRow = () => {
        if (this.rowDestroyed) return;
        const header = this.rowStage?.querySelector<HTMLElement>(':scope > router-outlet + * .reviewops-unified-header') || null;
        if (header !== this.rowHeader) {
            this.headerResize?.disconnect();
            this.rowHeader = header;
            if (header) this.headerResize?.observe(header);
        }
        if (!header || !window.matchMedia('(min-width: 1024px)').matches) {
            this.rowSidebar?.style.removeProperty('--reviewops-brand-row-size');
            return;
        }
        const height = header.getBoundingClientRect().height;
        if (!Number.isFinite(height) || height <= 0) return;
        const value = `${height}px`;
        if (this.rowSidebar!.style.getPropertyValue('--reviewops-brand-row-size') !== value) {
            this.rowSidebar!.style.setProperty('--reviewops-brand-row-size', value);
        }
    };

    public ngOnDestroy() {
        this.workspaceDialogs?.destroy();
        this.rowDestroyed = true;
        this.headerResize?.disconnect();
        this.routeChanges?.disconnect();
        window.removeEventListener('resize', this.queueHeaderRow);
        if (this.rowFrame) window.cancelAnimationFrame(this.rowFrame);
        this.rowSidebar?.style.removeProperty('--reviewops-brand-row-size');
    }

    public async openMobileNav(event: Event) {
        event.stopPropagation();
        this.navOpener = event.currentTarget instanceof HTMLElement ? event.currentTarget : null;
        this.mobileNavOpen = true;
        await this.service.render();
        if (this.rowDestroyed || !this.mobileNavOpen) return;
        this.element.nativeElement.querySelector<HTMLElement>('.reviewops-sidebar--mobile-drawer a[href]')?.focus();
    }

    public async closeMobileNav() {
        const drawer = this.element.nativeElement.querySelector('.reviewops-drawer');
        const restore = drawer?.contains(document.activeElement);
        this.mobileNavOpen = false;
        await this.service.render();
        if (!this.rowDestroyed && restore && this.navOpener?.isConnected) this.navOpener.focus();
    }

    @HostListener('document:keydown', ['$event'])
    public trapMobileNav(event: KeyboardEvent) {
        if (!this.mobileNavOpen || event.key !== 'Tab') return;
        const drawer = this.element.nativeElement.querySelector<HTMLElement>('.reviewops-drawer');
        const items = Array.from(drawer?.querySelectorAll<HTMLElement>('a[href],button:not(:disabled),input:not(:disabled),select:not(:disabled),[tabindex="0"]') || [])
            .filter(node => node.getClientRects().length > 0 && !node.closest('[hidden],[inert]'));
        const first = items[0], last = items[items.length - 1];
        if (!first) { event.preventDefault(); drawer?.focus(); return; }
        if (!drawer?.contains(document.activeElement) || (event.shiftKey && document.activeElement === first)) {
            event.preventDefault(); (event.shiftKey ? last : first).focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault(); first.focus();
        }
    }

    @HostListener('window:resize')
    public closeDesktopDrawer() {
        if (this.mobileNavOpen && window.matchMedia('(min-width: 1024px)').matches) void this.closeMobileNav();
    }

    @HostListener('document:keydown.escape')
    public async onEscape() {
        if (!this.mobileNavOpen) return;
        await this.closeMobileNav();
    }
}

export default LayoutSidebarComponent;